import { HttpErrorResponse } from '@angular/common/http';
import { AuthService } from 'src/app/services/auth/auth.service';
import { CustomSnackBarService } from '../components/custom-snack-bar/custom-snack-bar.service';

export class TrataExcessao {

    private static alreadyHandled: boolean = false;
    static TrataExcessao(err: HttpErrorResponse, authService: AuthService, snackBar: CustomSnackBarService): string[]
    {

        const actions: string[] = [];

        if (err.status === 401)
        {
            if (this.alreadyHandled) {
                return actions;
            }

            this.alreadyHandled = true;
            if (err.error.hasOwnProperty("ErrMsg"))
            {
                snackBar.openSnackBar(err.error.ErrMsg, null, "Error");   
            }
            else
            {
                snackBar.openSnackBar("Sessão Expirada", null, "Error");
            }
            authService.logout("",true);
        }
        else if (err.status === 500)
        {
            if(err?.error?.erros && err?.error?.erros.length > 0 ){
                for (let index = 0; index < err?.error?.erros.length; index++) {
                    const erro = err?.error?.erros[index];
                    snackBar.openSnackBar(erro.errorDescription, null, erro.errorType);
                    if(erro.errorType === 'Info' && !actions.includes(erro.errorSubType)){
                        actions.push(erro.errorSubType);
                    }
                }
                
            }
            else if(err?.error?.retorno?.erros && err?.error?.retorno?.erros.length > 0 ){
                for (let index = 0; index < err?.error?.retorno?.erros.length; index++) {
                    const erro = err?.error?.retorno?.erros[index];
                    snackBar.openSnackBar(erro.errorDescription, null, erro.errorType);
                    if(erro.errorType === 'Info' && !actions.includes(erro.errorSubType)){
                        actions.push(erro.errorSubType);
                    }
                }
            }
            else if (err.error.hasOwnProperty("ErrMsg"))
            {
                snackBar.openSnackBar(err.error.ErrMsg, null, "Error");
            }
            else
            {
                snackBar.openSnackBar(err.statusText, null, "Error");
            }
        }
        else if (err?.statusText){
            snackBar.openSnackBar(err.statusText, null, "Error");
        }
        else{
            snackBar.openSnackBar(err.toString(), null, "Error");
        }
        return actions;
    }

    static ResetAlreadyHandled() {
        this.alreadyHandled = false;
    }
}